import { Visibility } from "@mui/icons-material";

const VisibilityIcon = () => (
  <Visibility  />
);

export default VisibilityIcon;